class AnchorScroll {
  constructor() {
    this.anchorLinks = document.querySelectorAll('[href*="#"]');

    if (!this.anchorLinks.length) {
      return;
    }

    this.header = document.querySelector('.js-header');
    this.anchorLinksHandler();
  }

  scrollToAnchor = (anchor, e) => {
    if (anchor) {
      const target = document.querySelector(`${anchor}`);

      if (target) {
        if (e) {
          e.preventDefault();
        }
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  anchorLinksHandler() {
    this.anchorLinks.forEach((aLink) => {
      aLink.addEventListener('click', (e) => {
        const href = e.currentTarget.getAttribute('href');
        const anchor = href.match(/#.+/)?.[0];

        this.scrollToAnchor(anchor, e);

        if (this.header.classList.contains('has-nav-open')) {
          const navToggler = this.header.querySelector(
            '.js-nav-toggler.is-active',
          );

          if (navToggler) {
            navToggler.click();
          }
        }
      });
    });
  }
}

export default new AnchorScroll();
